import React from "react";
import UsersCommon from "../UsersMain";

const PendingUsers = () => {
  const verificationStatus = "Not Verified";
  const title = "Pending users";
  return <UsersCommon verificationStatus={verificationStatus} title={title} />;
};

export default PendingUsers;
